<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select
          v-model="filter.merchant"
          :items="$store.getters['admin/merchants']"
          item-text="name"
          item-value="idx"
          :label="$t('fields.merchant')"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="merchantCards"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <!-- <v-btn fab absolute bottom @click="edit({ status: 1 })" dark class="pink">
          <v-icon>mdi-credit-card-plus</v-icon>
        </v-btn>-->
        <v-speed-dial
          v-model="add_fab"
          bottom
          absolute
          direction="right"
          transition="slide-x-transition"
          class="mt-10"
        >
          <template v-slot:activator>
            <v-btn v-model="add_fab" color="pink" dark fab>
              <v-icon v-if="add_fab">mdi-close</v-icon>
              <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-btn fab dark small color="green" @click="edit({ status: 1 })">
            <v-icon>mdi-credit-card</v-icon>
          </v-btn>
          <v-btn fab dark small color="indigo" @click="dimport=true">
            <v-icon>mdi-credit-card-multiple</v-icon>
          </v-btn>
        </v-speed-dial>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template
        v-slot:item.merchant="{ item }"
      >{{ $store.getters["admin/merchant"](item.merchant).name }}</template>
      <template v-slot:item.status="{ item }">{{ $t("status.rec_" + item.status) }}</template>
      <template v-slot:item.fingerprint="{ item }">
        <v-icon>{{item.fingerprint?"mdi-check":"mdi-close"}}</v-icon>
      </template>
      <template v-slot:item.created="{ item }">{{ item.created | dt_time }}</template>
      <template v-slot:item.updated="{ item }">{{ item.updated | dt_time }}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.merchantCard">
            <template #idx>
              <span>{{item.idx}}</span>
            </template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.card"
              :error-messages="msg_errors"
              :label="$t('fields.card')"
              :disabled="item.idx != undefined"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-select
              v-model="item.merchant"
              :items="$store.getters['admin/merchants']"
              item-text="name"
              item-value="idx"
              :label="$t('fields.merchant')"
            ></v-select>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
          </v-form>
        </v-card-text>
        <v-card-text>
          <div v-if="item.fingerprint" class="mb-4">{{item.fingerprint}}</div>
          <v-layout>
            <v-flex v-for="(v,k) in item.datainfo" :key="k">
              <div v-if="v" class="text-caption">{{k}}</div>
              <div v-if="v" class="subtitle-2">{{v}}</div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm = true" color="primary">{{ $t("button.delete") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="item.fingerprint"
            text
            @click="freeCard"
            color="primary"
          >{{ $t("button.free") }}</v-btn>
          <v-btn text @click="update" color="primary">{{ $t("button.update") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dimport" fullscreen persistent>
      <v-card class="orange lighten-5">
        <v-card-title>
          <i18n path="merch.import" />
          <v-spacer />
          <v-btn @click="dimport = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="4">
              <v-form lazy-validation ref="excel_form">
                <v-select
                  v-model="excel_merchant"
                  :items="$store.getters['admin/merchants']"
                  item-text="name"
                  item-value="idx"
                  :label="$t('fields.merchant')"
                ></v-select>
              </v-form>
            </v-col>
            <v-col cols="4">
              <v-file-input v-model="excel_file" class="ml-4" style="width: 200px" />
            </v-col>
            <v-col cols="4" class="text-center">
              <v-radio-group v-model="excelField" row class="ml-4">
                <v-radio :value="h" :label="h" v-for="(h, i) in excel_headers" :key="i"></v-radio>
              </v-radio-group>
            </v-col>
            <!-- <v-col cols="4" align-self="center" class="text-right">
              <v-btn v-if="excel_json.length" text color="blue" @click="importCards"><i18n path="merch.import" /></v-btn>
            </v-col>-->
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-simple-table class="transparent">
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="(h, i) in excel_headers" :key="i" :class="colorForHeader(h)">{{ h }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in excel_page" :key="ind">
                  <td v-for="(h, i) in excel_headers" :key="i">{{ item[h] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-pagination
            v-if="excel_json.length"
            v-model="excel_cur_page"
            :length="excel_json_length"
            :total-visible="excel_max"
          ></v-pagination>
          <v-spacer></v-spacer>
          <v-btn v-if="excel_json.length" text color="blue" @click="importCards">
            <i18n path="merch.import" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{ $t("dialog.txt.delMerchantCard") }}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import XLSX from "xlsx";

export default {
  name: "AdminMerchantCards",
  mixins: [commonmixin],
  data() {
    return {
      item: {},
      filter: {
        merchant: "",
      },
      excel_file: null,
      excel_merchant: "",
      excel_cur_page: 1,
      excel_json: [],
      workbook: null,
      worksheet: null,
      excelField: "",
      excel_max: 10,
      add_fab: false,
      dimport: false,
      d_edit: false,
      msg_errors: "",
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
        { text: this.$t("fields.card"), value: "card" },
        {
          text: this.$t("fields.merchant"),
          value: "merchant",
          filter: (value) => {
            if (!this.filter.merchant) return true;

            return value == this.filter.merchant;
          },
        },
        {
          text: this.$t("fields.active"),
          value: "fingerprint",
          align: "center",
        },
        { text: this.$t("fields.status"), value: "status" },
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
      ],
    };
  },
  watch: {
    excel_file: {
      handler(file) {
        if (!file) {
          this.workbook = null;
          this.worksheet = null;
          this.excel_json = [];
          this.excelField = "";
          return;
        }
        const reader = new FileReader();
        reader.addEventListener("load", (event) => {
          try {
            let data = event.target.result;
            this.workbook = XLSX.read(data, { type: "binary" });
            const first_sheet_name = this.workbook.SheetNames[0];
            this.worksheet = this.workbook.Sheets[first_sheet_name];
            this.excel_json = XLSX.utils.sheet_to_json(this.worksheet);
            if (this.excel_json.length) {
              for (let i in this.excel_json[0]) {
                this.excelField = i;
                break;
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
        reader.readAsBinaryString(file);
      },
    },
  },
  computed: {
    excel_json_length() {
      try {
        return Math.ceil(this.excel_json.length / this.excel_max);
      } catch (error) {
        return 0;
      }
    },
    excel_headers() {
      if (!this.excel_json.length) return [];
      let a = [];
      for (let h in this.excel_json[0]) {
        a.push(h);
      }
      return a;
    },
    excel_page() {
      try {
        return this.excel_json.slice(
          this.excel_max * (this.excel_cur_page - 1),
          this.excel_max * this.excel_cur_page
        );
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    merchantCards() {
      return this.$store.getters["admin/merchantCards"];
    },
  },
  methods: {
    colorForHeader(h) {
      try {
        if (h == this.excelField) return "success";
      } catch (error) {
        console.log(error);
      }
      return "";
    },
    importCards() {
      if (!this.$refs.excel_form.validate() || !this.excel_json.length) {
        return;
      }
      this.$api
        .addMerchantCards(this.excel_merchant, {
          field: this.excelField,
          data: this.excel_json,
        })
        .then((r) => {
          console.log(r);
          try {
            if (r) {
              this.$store.dispatch("admin/LOAD_MERCHANTCARDS");
            }
          } catch (error) {
            console.log(error);
          }
          this.dimport = false;
        });
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.merchantCards.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_MERCHANTCARD", this.item).then(() => {
        this.d_edit = false;
      });
    },
    freeCard() {
      this.$store
        .dispatch("admin/FREE_MERCHANTCARD", {
          item: this.item,
          index: this.currentIdx,
        })
        .then(() => {
          this.d_edit = false;
        });
    },
    update() {
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_MERCHANTCARD", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.items.find((e) => {
          return e.card == this.item.card && e.merchant == this.item.merchant;
        });
        if (prev) {
          this.msg_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_MERCHANTCARD", this.item)
            .then((response) => {
              if (response == 0) {
                this.msg_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log("enter", to, from, next);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    console.log("update", to, from, next);
    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log("leave", to, from, next);
    next();
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_MERCHANTCARDS");
  },
};
</script>

<style scoped>
</style>